// extracted by mini-css-extract-plugin
export var closeButton = "_od-2";
export var closeButtonIcon = "_od-3";
export var lightboxContent = "_od-1";
export var lightboxOverlay = "_od-0";